<!-- 司机请假管理 -->
<template>
  <v-container fluid>
    <v-row class="query-row">
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="请假开始日期(起)" append-icon="mdi-calendar" readonly
              v-bind="attrs" v-on="on" dense outlined clearable hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="请假开始日期(止)" append-icon="mdi-calendar" readonly
              v-bind="attrs" v-on="on" dense outlined clearable hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.name" label="司机姓名" dense outlined clearable hide-details
          @keyup.enter="search()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-select v-model="queryForm.status" :items="statusItems" label="状态" no-data-text="无" dense outlined clearable
          hide-details :menu-props="{ bottom: true, offsetY: true }">
        </v-select>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6">
        <a-space>
          <v-btn @click="search()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
        </a-space>
      </v-col>
    </v-row>

    <v-card tile>
      <v-card-title class="d-flex align-center py-2 px-3" style="background-color: #fff;">
        <span class="text-subtitle-2">共 {{ count }} 条数据</span>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
              {{ limit }}/页
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in pages" :key="index" @click="limit = item.value">
              <v-list-item-title>{{ item.value }}/页</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false" bordered
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }">
        <!-- 请假开始/结束时间格式化 -->
        <template slot="start_time" slot-scope="text">
          <span>{{ formatTime(text) }}</span>
        </template>
        <template slot="end_time" slot-scope="text">
          <span>{{ formatTime(text) }}</span>
        </template>
        <template slot="create_time" slot-scope="text">
          <span>{{ formatTime(text) }}</span>
        </template>
        <!-- 状态：1 待审核 / 2(agree) 审核通过 / 3(refuse) 审核拒绝，兼容历史 agree/refuse 数据 -->
        <template slot="status" slot-scope="text">
          <a-tag v-if="text === '2' || text === 'agree'" color="green">已通过</a-tag>
          <a-tag v-else-if="text === '3' || text === 'refuse'" color="red">已拒绝</a-tag>
          <a-tag v-else color="orange">待审核</a-tag>
        </template>
        <template slot="audit_time" slot-scope="text">
          <span>{{ text ? formatTime(text) : '--' }}</span>
        </template>
        <template slot="audit_reason" slot-scope="text">
          <span>{{ text || '--' }}</span>
        </template>
        <template slot="audit_by" slot-scope="text">
          <span>{{ text || '--' }}</span>
        </template>
        <!-- 操作：仅待审核可审核（status 为 "1" 或其它非 agree/refuse/2/3 值） -->
        <template slot="action" slot-scope="text, record">
          <a v-if="isPending(record.status)" @click="showaudit(record)">审核</a>
          <span v-else class="grey--text">--</span>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>

    <!-- 审核弹窗 -->
    <v-dialog v-model="auditmodel" max-width="520" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          请假审核
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- 请假信息 -->
          <div class="mb-3 grey--text text--darken-2">
            <div>司机：{{ auditform.name }}（{{ auditform.mobile }}）</div>
            <div>请假时间：{{ formatTime(auditform.start_time) }} ~ {{ formatTime(auditform.end_time) }}，共
              {{ auditform.days }} 天</div>
            <div>请假原因：{{ auditform.reason || '--' }}</div>
          </div>
          <v-form ref="auditform" v-model="auditvalid" :lazy-validation="true">
            <!-- 审核结果：1 同意 / 2 拒绝 -->
            <v-radio-group v-model="auditform.type" row :rules="[vrules.required]">
              <v-radio color="success" label="同意" value="1"></v-radio>
              <v-radio color="error" label="拒绝" value="2"></v-radio>
            </v-radio-group>
            <!-- 拒绝时原因必填 -->
            <v-textarea v-model="auditform.audit_reason" label="审核原因" dense outlined rows="3"
              :rules="auditform.type === '2' ? [vrules.required] : []"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text tile @click="auditmodel = false">取消</v-btn>
          <v-btn color="primary" dark tile @click="audit">
            {{ auditform.type === '2' ? "确认拒绝" : "同意" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";

export default {
  name: "DriverLeave",
  data() {
    return {
      queryForm: {
        start_day: "",
        end_day: "",
        name: "",
        status: null,
      },
      start_day_menu: false,
      end_day_menu: false,
      // 查询用状态：已审批/未审批（后端映射：未审批=1，已审批=2或3）
      statusItems: [
        { text: "未审批", value: "0" },
        { text: "已审批", value: "1" },
      ],
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: "司机姓名", dataIndex: "name", width: 110, align: "center" },
        { title: "手机号", dataIndex: "mobile", width: 130, align: "center" },
        { title: "请假开始时间", dataIndex: "start_time", scopedSlots: { customRender: "start_time" }, width: 160, align: "center" },
        { title: "请假结束时间", dataIndex: "end_time", scopedSlots: { customRender: "end_time" }, width: 160, align: "center" },
        { title: "请假天数", dataIndex: "days", width: 90, align: "center" },
        { title: "请假原因", dataIndex: "reason", width: 200, align: "left", ellipsis: true },
        { title: "状态", dataIndex: "status", scopedSlots: { customRender: "status" }, width: 90, align: "center" },
        { title: "审核人", dataIndex: "audit_by", scopedSlots: { customRender: "audit_by" }, width: 100, align: "center" },
        { title: "审核时间", dataIndex: "audit_time", scopedSlots: { customRender: "audit_time" }, width: 160, align: "center" },
        { title: "审核原因", dataIndex: "audit_reason", scopedSlots: { customRender: "audit_reason" }, width: 160, align: "left", ellipsis: true },
        { title: "提交时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 160, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 90, align: "center", fixed: "right" },
      ],
      list: [],
      page: 1,
      limit: 20,
      length: 0,
      count: 0,
      height: 600,
      auditmodel: false,
      auditvalid: true,
      auditform: {},
      vrules: {
        required: (value) => !!value || "不能为空",
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 120), 0);
    },
  },
  watch: {
    page() { this.getdata(); },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 320;
    window.onresize = () => {
      this.height = window.innerHeight - 320;
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    // 判断是否待审核：排除已审批的值（2/agree 通过、3/refuse 拒绝）
    isPending(status) {
      return !["2", "3", "agree", "refuse"].includes(status);
    },
    formatTime(t) {
      return t ? this.$moment(t).format("YYYY-MM-DD HH:mm") : "--";
    },
    search() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicledriver/leave_list", {
        page: this.page,
        limit: this.limit,
        ...this.queryForm,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showaudit(record) {
      this.auditform = {
        _id: record._id,
        name: record.name,
        mobile: record.mobile,
        start_time: record.start_time,
        end_time: record.end_time,
        days: record.days,
        reason: record.reason,
        type: "1", // 1 同意 / 2 拒绝
        audit_reason: "",
      };
      this.auditmodel = true;
    },
    audit() {
      if (!this.$refs.auditform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicledriver/leave_audit", {
        _id: this.auditform._id,
        type: this.auditform.type,
        audit_reason: this.auditform.audit_reason,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success("已审核");
          this.auditmodel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/* 查询条件行与下方表格保持间距 */
/deep/ .row.query-row {
  margin-bottom: 16px !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

p {
  margin: 0;
}
</style>
